// authFetch.js
// Single helper that attaches Cognito token to every admin API call
import { fetchAuthSession } from "aws-amplify/auth";

export async function authFetch(url, options = {}) {
  try {
    const session = await fetchAuthSession();
    const token = session.tokens?.accessToken?.toString();

    if (!token) {
      throw new Error("No auth token available - please log in again");
    }

    const headers = {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    };

    return fetch(url, { ...options, headers });
  } catch (error) {
    console.error("authFetch error:", error);
    throw error;
  }
}
